import React from 'react';
import { Link } from "react-router-dom";
import axios from "axios";
import logoreg from "../abc.png"
import Path from "./config";
class Otpcomfirm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            sbg_otp: '',
            userId: null
        }
    }
    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId")
        })
        this.setState({
            phoneId: localStorage.getItem("phoneId")
        })


    }

    otpHandler = (e) => {
        document.getElementById("sbg_id1").innerHTML = " ";

        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_otp: e.target.value })
        }

    }

    submitClick = (e) => {
        let isValid = true;
        e.preventDefault();
        if (this.state.sbg_otp === "") {
            isValid = false;
            document.getElementById("sbg_id1").innerHTML = "Please Enter OTP ";
        }
        let tempStr = "sbg_OTP=" + this.state.sbg_otp +
            "&sbg_mobile_no=" + this.state.phoneId
        if (isValid === true) {
            axios.post(Path + `Suchi_Bride_Groom_otp.php?` + tempStr)
                .then(function (response) {
                    if (response.data.result === 'match') {
                        localStorage.setItem("userId", response.data.sbg_id)
                        this.props.history.push(`./Login`);
                    } else if (response.data.result === 'pending') {
                        localStorage.setItem("userId", response.data.sbg_id)
                        this.props.history.push(`./Payment`);
                    }
                    else {
                        alert("Invalid OTP.....")
                    }
                }.bind(this))
        }
    }
    resendClick = (e) => {

        let tempStr = "sbg_mobile_no=" + this.state.phoneId

        axios.post(Path + `suchi_bride_resend_otp.php?` + tempStr)
            .then(function (response) {

                if (response.data.Sucess === "OTP Send sucessfully.") {
                    document.getElementById("sbg_id1").innerHTML = "OTP resent. Please enter ";
                } else if (response.data.result === 'pending') {

                }
                else {
                    alert("Invalid OTP.....")
                }
            }.bind(this))

    }


    render() {
        //console.log("localstorageeeeeeeeeeeeeeee",this.state.phoneId)
        return (
            <>
                <div className="container-fluid">
                    <span className="align-middle d-flex justify-content-center"><img src={logoreg} alt="logo" style={{ width: "300px" }}></img></span>

                    <div className="row justify-content-md-center my-5 ">

                        <div className="col-md-8 border  border-5 p-3 mb-2 bg-light text-dark">
                            <div className="mb-3 text-md-center  text-primary">
                                <h3> तुमच्या {this.state.phoneId} या नंबर वरती आलेला OTP टाकावा.</h3>
                                {/* <p> तुमच्या {this.state.phoneId} या नंबर वरती आलेला OTP टाकावा.</p> */}


                            </div>
                            <div className="mb-3 pt-4">

                                <input type="text" value={this.state.sbg_otp} onChange={this.otpHandler} className="form-control border-top-0 border-right-0 border-left-0 border-3 border-danger border-bottom " id="sbg_otp" placeholder="Enter OTP" required />
                                <br></br> <span id="sbg_id1" className="text-danger"></span>
                            </div>
                            <div className="mb-3 text-right text-primary ">
                                <button type="button" className='resendButton' onClick={(e) => (this.resendClick) ? this.resendClick(e) : null}>  Resend OTP</button>
                            </div>
                            <div className="mb-3 text-center my-5">
                                <Link to="/FormProfile">
                                    <button type="button" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null} className="btn btn-success m-2"> Validate 👍 </button>
                                </Link>


                            </div>
                            <div className="mb-3 text-md-center ">
                                <p>जर आपल्याला OTP आलाच नसेल तर हातोहात तुमच्या रजिस्टर नंबर वरून 9420309965 किंवा 9730550506 या ऑफिस च्या नंबर वर कॉल करून आमच्या कडून OTP विचारून घ्यावा. ही विनंती</p>
                            </div>
                        </div>
                    </div>

                </div>

            </>
        )
    }
}

export default Otpcomfirm
